import { forwardRef, useCallback } from 'react';

import { useMatch, useNavigate } from '@spazious/dollhouse-router';
import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexElement, FlexProps } from '@spazious/dollhouse-uikit';

import { ROUTE_PATH_ROOT } from '../../constants/index.js';
import { SideMenu } from '../SideMenu/index.js';
import { SidePanel } from '../SidePanel/index.js';

export type SideBarElement = FlexElement;

export interface SideBarProps extends FlexProps {}

export const SideBar = styled(
  forwardRef<SideBarElement, SideBarProps>(({ children, ...restProps }, ref) => {
    const navigate = useNavigate();
    const matched = useMatch('/');

    const handlePanelClose = useCallback(() => {
      navigate(ROUTE_PATH_ROOT);
    }, [navigate]);

    return (
      <Flex ref={ref} {...restProps}>
        <SideMenu />
        <SidePanel open={!matched} onClose={handlePanelClose}>
          {children}
        </SidePanel>
      </Flex>
    );
  })
).withConfig({
  displayName: 'SideBar',
})<SideBarProps>`
  height: 100%;
`;
